import React from 'react'

class DziovyklosComponent extends React.Component {
    render() {
        return <div  className="content">
        <iframe  allowfullscreen="" frameborder="0" height="315" width="420" src="https://www.youtube.com/embed/eeq38hrUXgk"></iframe>
        <div  id="dsc">
          <h1 >Pjuvenų džiovyklos</h1>
          <p >Būgninė džiovykla su šilumokaičiu
            Našumas iki 500/ 1000/1500 kg/h
            </p>
          <p > Būgninė džiovykla
            Našumas iki 1000/2000 kg/h
            </p>
            <p >
              Juostinės džiovyklos
              Našumas iki 450/450/ 1700 kg/h            
            </p>
        </div>
      </div>
    }
}

export default DziovyklosComponent